import { useEffect, useRef } from 'react'
import type { TelegramWidgetUser } from '../telegram'

interface Props {
  botUsername: string
  onAuth: (user: TelegramWidgetUser) => void
}

/** Кнопка Telegram Login Widget. Работает только на домене, который указан боту через /setdomain. */
export function TelegramLoginWidget({ botUsername, onAuth }: Props) {
  const box = useRef<HTMLDivElement>(null)
  const onAuthRef = useRef(onAuth)

  useEffect(() => {
    onAuthRef.current = onAuth
  }, [onAuth])

  useEffect(() => {
    const el = box.current
    if (!el) return
    window.onTelegramAuth = (user) => onAuthRef.current(user)
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?22'
    script.async = true
    script.dataset.telegramLogin = botUsername
    script.dataset.size = 'large'
    script.dataset.radius = '10'
    script.dataset.userpic = 'false'
    // write: бот сможет присылать сводку и файлы
    script.dataset.requestAccess = 'write'
    script.dataset.onauth = 'onTelegramAuth(user)'
    el.appendChild(script)
    return () => {
      el.replaceChildren()
      delete window.onTelegramAuth
    }
  }, [botUsername])

  return <div ref={box} className="flex min-h-10 justify-center" />
}
